import Lookup from 'src/componentes/select2';

const TemaEstrategico = ({ multi = true, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    multi={multi}
    url="/TemaEstrategicoLookup"
    {...rest}
  />
);

export default TemaEstrategico;
